import { Component, HostListener, Input, OnInit } from '@angular/core';
import { SearchStudent } from '../../model/searchStudent';
import { StudentHelperService } from '../../service/student-helper.service';
import { HelperService } from 'src/app/service/helper.service';
import { Region } from 'src/app/model/region.model';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { InaSchoolEnrollmentsService } from '../../service/ina-school-enrollments.service';
import { EditableInaSchoolEnrollment, InaSchoolEnrollment } from './model/ina-school-enrollment';
import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { ProgressSpinnerSet, UtilityService } from 'src/app/service/utility.service';
import { Router } from '@angular/router';

const groupBy = <T, K extends keyof any>(arr: T[], key: (i: T) => K) =>
    arr.reduce((groups, item) => {
        (groups[key(item)] ||= []).push(item);
        return groups;
    }, {} as Record<K, T[]>);

@Component({
    selector: 'app-ina',
    templateUrl: './ina.component.html',
    styleUrls: ['./ina.component.scss']
})
export class InaComponent implements OnInit {
    @Input() studentId: number;    
    @Input() editing: boolean;

    lstEditableInaSchoolEnrollment: EditableInaSchoolEnrollment[] = [];

    lstRegionbyGroup: Array<any> = [];
    userRegion: Region;
    searchStudent: SearchStudent;
    boolFoundINAILP: boolean = true;
    addAccess: boolean = false;
    isLoading: boolean = true;
    studentName:string='';
    @HostListener('window:focus', ['$event'])
    onFocus(event: any): void {
        this.invokeApiGetINA(new EditableInaSchoolEnrollment());
    }

    constructor(
        private router: Router,
        public studentHelperService: StudentHelperService,
        public helperService: HelperService,
        public accessService: AccessService,
        public inaSchoolEnrollmentsService: InaSchoolEnrollmentsService,
    ) {}
    ngOnInit(): void {
        this.subscriptions();
        this.invokeApiGetINA(new EditableInaSchoolEnrollment());

        // Add a delay of 2 seconds (2000 milliseconds)
        setTimeout(() => {
            this.invokeApiGetINA(new EditableInaSchoolEnrollment());
        }, 2000);
    }

    subscriptions() {

        this.accessService.featureAccessible('Create INA/ILP').subscribe((x) => {if (x) {this.addAccess = x; }});

        this.studentHelperService.studentName$.subscribe((studentName) => {
            this.studentName = studentName;
        });

        this.studentHelperService.searchStudent$.subscribe((sStudent) => {
            this.searchStudent = sStudent;
        });
        this.helperService.lstUserProfileRegion$.subscribe((userRegion: Region[]) => {
            this.userRegion = userRegion[0];
        });
    }

    invokeApiGetINA(action: EditableInaSchoolEnrollment) {
        if (action?.isDelete == true) {
            this.lstEditableInaSchoolEnrollment = this.lstEditableInaSchoolEnrollment.filter(
                (u: EditableInaSchoolEnrollment) => u.inaSchoolEnrollment.Id !== action.inaSchoolEnrollment.Id
            );
            this.groupbyRegionCode();
        } else {
            this.inaSchoolEnrollmentsService.getINASchoolEnrollments('?StudentId=' + this.studentId.toString()).subscribe((x) => {
                if (x['msg'] !== undefined) {
                    this.lstEditableInaSchoolEnrollment = [];
                } else {
                    this.lstEditableInaSchoolEnrollment = [];
                    let y: InaSchoolEnrollment[] = x['inaSchoolEnrollment'];

                    y.forEach((element) => {
                        element.CreatedDate = new CleanDatePipe().transform(element.CreatedDate!);
                        this.lstEditableInaSchoolEnrollment.push({ isEdit: false, inaSchoolEnrollment: element, isDelete: false });
                    });
                    const now = new Date().getTime();

                    this.lstEditableInaSchoolEnrollment.sort((a, b) => {
                        return (
                            (b.inaSchoolEnrollment.CreatedDate ? b.inaSchoolEnrollment.CreatedDate!.getTime() : now) -
                            (a.inaSchoolEnrollment.CreatedDate ? a.inaSchoolEnrollment.CreatedDate!.getTime() : now)
                        );
                    });
                }
                this.groupbyRegionCode();
            });
        }
    }

    groupbyRegionCode() {
        this.lstRegionbyGroup = [];
        const record = groupBy(this.lstEditableInaSchoolEnrollment, (i) => i.inaSchoolEnrollment.RegionId.toString());
        Object.keys(record).map((key) => {
            let a: EditableInaSchoolEnrollment[] = record[key];
            this.lstRegionbyGroup.push({ id: key, editableINA: a });
        });

        this.boolFoundINAILP = this.lstRegionbyGroup.length > 0 ? true : false;
        this.isLoading = false;
    }

    addRow() {
        let routeURL: string = ''
        routeURL = '/children/'+ this.studentId+'/ina/create';
        const url = this.router.serializeUrl(
            this.router.createUrlTree([routeURL])
        );

        window.open(routeURL, '_blank');
        

    }
}
